import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { SupplierValidationDocument, SupplierValidationRecord } from '@mortee/domain/validationSystem';
import Loadable from '@app/utils/Loadable';
import { SidePadding, TabTitle } from '@mortee/routes/validationSystem/editValidtionRecord/EditValidationRecordStyles';
import SupplierValidationRecordDocuments from '@mortee/routes/validationSystem/editValidtionRecord/mainTabs/SupplierValidationRecordDocuments';

interface Props {
  record: SupplierValidationRecord;
  documents: Loadable<SupplierValidationDocument[]>;
  className?: string;
  onDocumentClick?(document: SupplierValidationDocument): void;
}

const EditValidationRecordDocumentsTab: FC<Props> = observer((props) => {
  const { record, documents, className, onDocumentClick } = props;

  return (
    <SidePadding className={className}>
      <TabTitle>Documents</TabTitle>
      <SupplierValidationRecordDocuments record={record} documents={documents} onDocumentClick={onDocumentClick} />
    </SidePadding>
  );
});

export default EditValidationRecordDocumentsTab;
